export enum MessageTexts {
  DUPLICATED_VIDEOS = 'We recognize that there may be duplicate videos after selection. This happens when you clip one video in the Photos app. We recommend using apps like CapCut to make clips or film each step as a separate video.',
}
